import { render, staticRenderFns } from "./Pop-logo.vue?vue&type=template&id=1cb517ea"
import script from "./Pop-logo.vue?vue&type=script&lang=js"
export * from "./Pop-logo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports